const rutaImgProducto = '/image/tienda/productos_img_png'

export const imagenesCarousel = [    
    {id:1, url:"/image/inicio/carousel/FX300071.webp"},    
    {id:2, url:"/image/inicio/carousel/FX300076.webp"},    
    {id:3, url:"/image/inicio/carousel/FX300062.webp"},
]

export const listaProductos = [
    {
        id:1, 
        tipo: "mosto-verde",
        nombre:"Pisco Mosto Verde Puro Mollar", 
        precioNormal:89, 
        precioOferta:"", 
        imagen:`${rutaImgProducto}/pisco2.png`,
        nuevo: true,
        informacion: "Suprema combinación para un chilcano premium."
    },
    {
        id:2,
        tipo: "mosto-verde", 
        nombre:"Pisco Mosto Verde Puro Italia", 
        precioNormal:89, 
        precioOferta:"", 
        imagen:`${rutaImgProducto}/pisco3.png`,
        nuevo: true,
        informacion: "La engreída y el orgullo de la casa. Aroma floral y sabor aterciopelado."
    },
    {
        id:3, 
        tipo: "mosto-verde",
        nombre:"Pisco Mosto Verde Acholado Mollar Italia", 
        precioNormal:89, 
        precioOferta:"", 
        imagen:`${rutaImgProducto}/pisco1.png`,
        nuevo: true,
        informacion: "Suprema combinación para un chilcano premium."
    },
    {
        id:4, 
        tipo: "puro",
        nombre:"Pisco Puro Italia", 
        precioNormal:49, 
        precioOferta:"", 
        imagen:`${rutaImgProducto}/pisco4.png`,
        nuevo: false,
        informacion: "Cepa tradicional y aromática. Ideal como bajativo"
    },
    {
        id:5, 
        tipo: "puro",
        nombre:"Pisco Puro Quebranta", 
        precioNormal:49, 
        precioOferta:"", 
        imagen:`${rutaImgProducto}/pisco5.png`,
        nuevo: false,
        informacion: "Nuestra cepa más tradicional. Tómalo como abrebocas o en cóctel como pisco sour."
    },
    {
        id:6, 
        tipo: "puro",
        nombre:"Pisco Puro Mollar", 
        precioNormal:49, 
        precioOferta:"", 
        imagen:`${rutaImgProducto}/pisco6.png`,
        nuevo: false,
        informacion: "Cepa aromática redescubierta. Excelente para un buen pisco sour."
    },
    {
        id:7, 
        tipo: "acholado",
        nombre:"Pisco Acholado Quebranta - Italia", 
        precioNormal:49, 
        precioOferta:"", 
        imagen:`${rutaImgProducto}/pisco7.png`,
        nuevo: false,
        informacion: "El blend más tradicional y clásico. Recomendado para chilcano y usado también para pisco sour."
    },
    {
        id:8, 
        tipo: "acholado",
        nombre:"Pisco Acholado Mollar - Italia", 
        precioNormal:49, 
        precioOferta:"", 
        imagen:`${rutaImgProducto}/pisco8.png`,
        nuevo: false,
        informacion: "Sabroso para el chilcano y cuando quieras combinar lo mejor de las dos sensaciones: aroma y sabor."
    }
]

export const imagenesSeccionNosotros = [
    {id:1, url:"/image/nosotros/img1.png"},
    {id:2, url:"/image/nosotros/img2.png"},
    {id:3, url:"/image/nosotros/img3.png"},
    {id:4, url:"/image/nosotros/img4.png"},
    {id:5, url:"/image/nosotros/img5.png"},
]

export const imagenesSeccionGaleria = [
    {id:1, url:"/image/galeria/GL00001.webp"},
    {id:2, url:"/image/galeria/GL00002.webp"},
    {id:3, url:"/image/galeria/GL00003.webp"},
    {id:4, url:"/image/galeria/GL00004.webp"},
    {id:5, url:"/image/galeria/GL00005.webp"},
    {id:6, url:"/image/galeria/GL00006.webp"},
    {id:7, url:"/image/galeria/GL00007.webp"},
    {id:8, url:"/image/galeria/GL00008.webp"},
    {id:9, url:"/image/galeria/GL00009.webp"},
    {id:10, url:"/image/galeria/GL00010.webp"},
    {id:11, url:"/image/galeria/GL00011.webp"},
    {id:12, url:"/image/galeria/GL00012.webp"},
    {id:13, url:"/image/galeria/GL00013.webp"},
    {id:14, url:"/image/galeria/GL00014.webp"},
    {id:15, url:"/image/galeria/GL00015.webp"},
    {id:16, url:"/image/galeria/GL00016.webp"}    
]